/* The start page (see start.tsx), over everything until the player starts. */

.start {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 24px 16px;
  background: linear-gradient(180deg, #fff8ee 0%, #f6e6d2 100%);
  /* Seen at its edge as it slides away over the workshop. */
  box-shadow: 8px 0 32px rgba(120, 80, 50, 0.18);
  cursor: pointer;
  user-select: none;
  z-index: 20;
}

.heading {
  margin: 0;
}

.logo {
  display: block;
  width: min(460px, 82vw);
}

/* As tall as the paw prints it takes the place of, so nothing moves. */
.prompt {
  display: grid;
  place-items: center;
  height: 58px;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--accent);
  animation: beckon 1.6s ease-in-out infinite;
}

@keyframes beckon {
  50% {
    opacity: 0.45;
  }
}

.notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 18px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fffaf3;
  text-align: center;
}

.notice p {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.notice svg {
  color: var(--accent);
}

.notice small {
  font-size: 12px;
  color: var(--ink-soft);
}
